import { FiDroplet, FiFeather, FiWind, FiMoon } from 'react-icons/fi'

export const SAMPLE_DIAGNOSTICS = {
  photoUrl: null, // string URL, or null for placeholder
  hairType: '4B — COILY', // shown on the photo overlay
  hairTypeCode: '4B', // big stat number
  hairTypeName: 'COILY', // pill under it
  healthScore: 89, // 0–100, drives the gauge
  hairGoal: 'LONGER HAIR',
  superpowerTitle: 'THICK & STRONG STRANDS',
  superpowerSub: 'You have amazing density and strong hair!',
}

export const SAMPLE_ROUTINE = {
  photoUrl: null,
  hairType: '4B — COILY',
  hairGoal: 'LONGER HAIR',
  superpowerTitle: 'THICK & STRONG STRANDS',
  superpowerSub:
    'Your strong, dense strands thrive with this nourishing routine — it helps retain length, improve resilience and reduce breakage.',
  steps: [
    {
      icon: <FiDroplet size={18} />,
      title: 'Pre-poo',
      sub: 'with warm oil blend',
    },
    {
      icon: <FiFeather size={18} />,
      title: 'Cleanse',
      sub: 'Sulphate-free cleanse, scalp focus',
    },
    {
      icon: <FiWind size={18} />,
      title: 'Deep Condition',
      sub: 'with heat, 25 min',
    },
    {
      icon: <FiWind size={18} />,
      title: 'Moisturize',
      sub: 'LOC method on damp hair',
    },
    {
      icon: <FiMoon size={18} />,
      title: 'Protect',
      sub: 'Silk scarf before bed',
    },
  ],
}
